<div class="center-spinner loading">
  <mat-spinner></mat-spinner>
</div>
